import {
  LIST_LOYALTY_TRANSACTIONS_REQUEST,
  RESET_LOYALTY_TRANSACTION_QUERY
} from './constants';

export const listLoyaltyTransactions = (queryString) => ({
  type: LIST_LOYALTY_TRANSACTIONS_REQUEST,
  queryString
});

export const resetLoyaltyTransactionQuery = () => ({
  type: RESET_LOYALTY_TRANSACTION_QUERY
});
